export default {
  // list
  'config.query.configName': 'Config Name',
  'config.query.configName.placeholder': 'Enter config name',
  'config.query.configKey': 'Config Key',
  'config.query.configKey.placeholder': 'Enter config key',
  'config.query.configType': 'System Built-in',
  'config.column.configName': 'Config Name',
  'config.column.configKey': 'Config Key',
  'config.column.configValue': 'Config Value',
  'config.column.configType': 'System Built-in',
  'config.column.configType.yes': 'Yes',
  'config.column.configType.no': 'No',
  'config.column.remark': 'Remark',
  // edit
  'config.edit.title': 'Edit Config',
  'config.add.title': 'Add Config',
  'config.edit.success': 'Edit Successful',
  'config.add.success': 'Addition Successful',
  'config.form.configName': 'Config Name',
  'config.form.configName.placeholder': 'Please enter the config name',
  'config.form.configName.required': 'Config name cannot be empty',
  'config.form.configKey': 'Config Key',
  'config.form.configKey.placeholder': 'Please enter the config key',
  'config.form.configKey.required': 'Config key cannot be empty',
  'config.form.configValue': 'Config Value',
  'config.form.configValue.placeholder': 'Please enter the config value',
  'config.form.configValue.required': 'Config value cannot be empty',
  'config.form.configType': 'System Built-in',
  'config.form.configType.yes': 'Yes',
  'config.form.configType.no': 'No',
  'config.form.remark': 'Remark',
  'config.form.remark.placeholder': 'Please enter the remark',
}
